import { Injectable } from "@angular/core";
import * as JWT from "../../../../node_modules/jwt-decode/lib";
import { Router,NavigationExtras } from "@angular/router";
import { SnackBarService } from "../../shared/service/snack.bar.service";
import { LoginGQL, LogoutGQL } from "../../../generated/graphql";
import { UserService } from "../../shared/service/user.service";
import { NavigationService } from "../../shared/service/navigation.service";

export enum AccessTokenType {
  ACCESS = "JwtAccessToken",
  API = "p365ApiToken",
  REFRESH = "JwtRefreshToken",
}
 
export enum UserRoleType {
  PropertyAdmin = "Property Admin",
}

@Injectable()
export class AuthService {
  userContext: any;

  constructor(
    private LoginGQL: LoginGQL,
    private LogoutGQL: LogoutGQL,
    private router: Router,
    private snackBarService: SnackBarService,
    private navigationService: NavigationService,
    private userService: UserService
  ) {
    this.getTokenDetails();
  }

  login(email: string, password: string) {
    this.navigationService.clearState();
    password = this.userService.PasswordEncrypt(password);
    this.LoginGQL.fetch({ LoginId: email, Password: password }).subscribe(
      (data) => {
        if (data.errors) {
          this.snackBarService.show(
            data.errors.map((x) => x.message).join(",")
          );
        }
        this.setToken(data.data.login);
        this.getTokenDetails();
        let returnUrl = sessionStorage.getItem("lastUrl");
        if (returnUrl) {
          let url = this.navigationService.getUrl(returnUrl);
          let params = this.navigationService.getURLParameters(returnUrl);

          let navigationExtras: NavigationExtras = {
            queryParams: params,
          };
          this.router.navigate([url], navigationExtras);

          sessionStorage.removeItem("lastUrl");
        }
        else
          this.router.navigate(["../../project-setting/project-list"]);
      }
    );
  }

  logout() {
    this.LogoutGQL.fetch().subscribe((result) => {
      if (result.errors) {
        sessionStorage.clear();
        this.snackBarService.show(
          result.errors.map((x) => x.message).join(",")
        );
      }
      sessionStorage.clear();
      location.href = "/authentication/login";
    });
  }

  isLoggedIn(): boolean {
    if (this.userContext) {
      return !this.isTokenExpired();
    }
    return false;
  }

  activeLogin() {
    if (this.isLoggedIn()) {
      this.router.navigate(["../../project-setting/project-list"]);
    }
  }

  getToken(key?) {
    return sessionStorage.getItem(key || AccessTokenType.ACCESS);
  }

  isInRoles(role: UserRoleType): boolean {
    var roleKey = this.getEnumKeyByEnumValue(UserRoleType, role);
    if (Array.isArray(this.userContext.roleNames)) {
      return this.userContext.roleNames.some((x) => x == roleKey);
    }
    return false;
  }

  getEnumKeyByEnumValue(myEnum, enumValue) {
    let keys = Object.keys(myEnum).filter((x) => myEnum[x] == enumValue);
    return keys.length > 0 ? keys[0] : null;
  }

  public setToken(accessToken, key?) {
    sessionStorage.setItem(key || AccessTokenType.ACCESS, accessToken);
  }
  private setRefreshToken(refreshToken) {
    sessionStorage.setItem(AccessTokenType.REFRESH, refreshToken);
  }

  private getRefreshToken() {
    sessionStorage.getItem(AccessTokenType.REFRESH);
  }
  private isTokenExpired(): boolean {
    let expireTime = new Date(this.userContext.expireTime * 1000);
    return expireTime < new Date();
  }
  private getTokenDetails() {
    let token = this.getToken();

    if (token) {
      let decoded = JWT(token);
      let tokenDetails = {
        userId: decoded["userID"],
        expireTime: decoded["exp"],
        accountId: decoded["accountID"],
      };
      this.userContext = tokenDetails;
    }
  }
}
